import styled from '@emotion/styled'
import React from 'react'
import { useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { GridId } from 'store/grid'
import { SelectionActions } from 'store/selection'
import * as constants from 'view/styles/constants'
import { removeUrlParamPlaceholders } from 'view/routes/routeConfig'

const CollectionNameStyled = styled(NavLink)`
  cursor: pointer;
  margin-left: 10px;
  font-weight: ${constants.FontWeight.Bold};
  color: ${constants.CORE_PRIMARY_6};
`

export const InitiatedCollectionNameLink = ({ collectionId, label }: { collectionId: string | null; label: string }) => {
  const dispatch = useDispatch()

  return (
    <CollectionNameStyled
      data-test-id={`RowGroup-${label}`}
      to={removeUrlParamPlaceholders('/initiated')}
      onClick={() => {
        dispatch(SelectionActions.setCollectionId(GridId.InitiatedGrid, collectionId))
      }}>
      {label}
    </CollectionNameStyled>
  )
}
